export default "__VITE_ASSET__Wv4qrnR1__"